export const VIDEO_FORMATS = Object.seal({
  Horizontal: {
    width: 1920,
    height: 1080,
    aspectRatio: 1920 / 1080,
    aspectRatioText: '16:9',
    i18nKey: 'i18n.global.videoFormat.horizontal',
    i18nKeyExtended: 'i18n.global.videoFormat.horizontal.extended',
    icon: 'VideoFormatHorizontalIcon',
    special: false,
  },
  Vertical: {
    width: 1080,
    height: 1920,
    aspectRatio: 1080 / 1920,
    aspectRatioText: '9:16',
    i18nKey: 'i18n.global.videoFormat.vertical',
    i18nKeyExtended: 'i18n.global.videoFormat.vertical.extended',
    icon: 'VideoFormatVerticalIcon',
    special: false,
  },
  Square: {
    width: 1080,
    height: 1080,
    aspectRatio: 1080 / 1080,
    aspectRatioText: '1:1',
    i18nKey: 'i18n.global.videoFormat.square',
    i18nKeyExtended: 'i18n.global.videoFormat.square.extended',
    icon: 'VideoFormatSquareIcon',
    special: true,
  },
  SocialMedia: {
    width: 1080,
    height: 1350,
    aspectRatio: 1080 / 1350,
    aspectRatioText: '4:5',
    i18nKey: 'i18n.global.videoFormat.socialMedia',
    i18nKeyExtended: 'i18n.global.videoFormat.socialMedia.extended',
    icon: 'VideoFormatSocialMediaIcon',
    special: true,
  },
} as const);

export type VideoFormat = keyof typeof VIDEO_FORMATS;
export type VideoFit = 'Fit' | 'Crop';
export type VideoCaptureSource = 'NativeApp' | 'Screen' | 'Webcam';

export const VIDEO_FORMAT_MAX_SIZE = {
  width: Math.max(...Object.values(VIDEO_FORMATS).map((format) => format.width)),
  height: Math.max(...Object.values(VIDEO_FORMATS).map((format) => format.height)),
};
